/**
 * Sprint 12+W5 (12.07.2026) — Single Source of Truth für rechtliche
 * Referenzen. Die kanonischen Rechtstexte werden auf der Marken-Domain
 * https://effektiv-kommunizieren.de gehostet (Flex4Success ist Subdomain).
 *
 * Legal-Links-Konsistenz-Update (Do10.09.2026 18:00): Umstellung von
 * aj-kommunikation.de auf die konsistente Marken-Domain für einheitliche
 * User-Experience. `kontaktMail` bleibt auf aj-kommunikation.de-Adresse,
 * da das eine echte Mailbox ist (kein URL-Ziel).
 *
 * Diese Datei ist die eine Stelle, an der die drei URLs gepflegt werden.
 */

export const LEGAL_LINKS = {
  impressum: "https://effektiv-kommunizieren.de/impressum",
  datenschutz: "https://effektiv-kommunizieren.de/datenschutz",
  kontaktMail: "hello@aj-kommunikation.de",
};

export const LEGAL_CONTACT_MAILTO = `mailto:${LEGAL_LINKS.kontaktMail}`;
